var render, staticRenderFns
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"
import style0 from "./chatList.vue?vue&type=style&index=0&id=2c589e27&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c589e27')) {
      api.createRecord('2c589e27', component.options)
    } else {
      api.reload('2c589e27', component.options)
    }
    
  }
}
component.options.__file = "src/packages/main/src/page/chatPage/content/chat/chatList.vue"
export default component.exports